/** Messages sent while the agent was working: posted together, in order, once it has
 * finished the turn it is on. Until then they are shown here, and can be taken back. */
import {
  useStatefulRun,
  useRemoveQueuedMessage,
} from "../api/hooks/useStatefulAgents";
import { AnsweredQuestion } from "./AnsweredQuestion";
import { MessageImages } from "./MessageImages";
import styles from "./Review.module.css";

export const QueuedMessages = ({ runId }: { runId: string }) => {
  const { data } = useStatefulRun(runId);
  const remove = useRemoveQueuedMessage(runId);
  const queued = data?.queued_messages ?? [];
  if (queued.length === 0) return null;
  const n = queued.length;
  return (
    <div className={`${styles.submission} ${styles.queued}`}>
      <p className={styles.submissionHead}>
        Queued · {n} message{n === 1 ? "" : "s"}, sent to the agent together
        once it has finished this turn
      </p>
      <ul className={styles.threadList}>
        {queued.map((q) => (
          <li key={q.message_id} className={styles.queuedItem}>
            {q.turn_flags?.answered_question ? (
              <AnsweredQuestion answer={q.turn_flags.answered_question} />
            ) : (
              <div className={styles.queuedText}>{q.content}</div>
            )}
            {q.images.length ? <MessageImages images={q.images} /> : null}
            {q.documents?.length ? (
              <p className={styles.attached}>
                Attached: {q.documents.map((d) => d.name).join(", ")}
              </p>
            ) : null}
            <button
              type="button"
              className={styles.link}
              disabled={remove.isLoading}
              onClick={() => remove.mutate(q.message_id)}
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
      {remove.error && (
        <p className={styles.queuedError}>{remove.error.message}</p>
      )}
    </div>
  );
};
